export class ColumnToggleNewMessages {
    public static readonly DISPLAYED_COLUMNS = 'column-toggle.displayed-columns';
}